import { StatusIndicator } from '@cloudscape-design/components';
import { InspectionValues } from '@parallel-fluidics/shared/constants';
import PropTypes from 'prop-types';
import React from 'react';

const INSPECTION_STATUS_TYPE = Object.freeze({
  [InspectionValues.NOT_INSPECTED]: 'pending',
  [InspectionValues.PASSED]: 'success',
  [InspectionValues.REJECT_MAJOR]: 'error',
  [InspectionValues.REJECT_COSMETIC]: 'warning',
  [InspectionValues.TUNING]: 'info',
});

/**
 * A traveler step's inspection result, the one way it's shown everywhere
 * (process-data traveler status, inventory travelers table, traveler page
 * step rows): the raw InspectionValues label as a status indicator.
 */
export default function InspectionStatus({ inspected = null }) {
  return (
    <StatusIndicator type={INSPECTION_STATUS_TYPE[inspected] || 'info'}>
      {inspected || InspectionValues.NOT_INSPECTED}
    </StatusIndicator>
  );
}

InspectionStatus.propTypes = {
  inspected: PropTypes.string,
};
